<template>
    <b-card title="System Promo">
        <b-col cols="12">
            <b-table
                :fields="fields"
                :items="systemPromo"
                show-empty
                responsive
            >
                <template #cell(actions)="row">
                    <b-dropdown variant="primary" size="sm" text="Menu" no-caret dropright>
                        <template #button-content>
                            <feather-icon size="1x" icon="MenuIcon" />
                        </template>
                        <b-dropdown-item style="text-align:center" v-if="permission.view">
                            <b-button variant="info" @click="toViewSystemPromo(row.item._id)">
                                <feather-icon icon="EyeIcon"/>
                            </b-button>
                        </b-dropdown-item>
                        <b-dropdown-item style="text-align:center" v-if="permission.edit">
                            <b-button variant="outline-primary" @click="toEditSystemPromo(row.item._id)">
                                <feather-icon icon="EditIcon"/>
                            </b-button>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
        </b-col>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import {userAccess} from '@/utils/utils'

export default {
    data() {
        return {
            fields: [
                { key: 'name', text: 'Name' },
                { key: 'compressor', text: `Compressor (Unit)>=` },
                { key: 'fanCoil', text: `Fan Coil (Unit)>=` },
                { key: 'updatedBy', text: `Updated By` },

                { key: 'actions', text: 'Action' }
            ],
            systemPromo: [],
        }
    },
    mounted() {
        this.getSystemPromo().then((data) => {
            this.systemPromo = data;
        })
    },
    methods: {
        ...mapActions({
            getSystemPromo: 'systemPromo/getSystemPromo'
        }),
        toEditSystemPromo(id) {
            this.$router.push(`/system-promo/edit/${id}`)
        },
        toViewSystemPromo(id) {
            this.$router.push(`/system-promo/view/${id}`)
        }
    },
    computed: {
        permission() {
      return userAccess("System Promo", "warranty_master_menu");
    },
    },
    created() {
    document.title = 'System Promo | RSP'
  },
}
</script>